
import CONSTANTS from '../constants'
import { getRequest, postRequest } from '../../services'
import { APICONFIG } from '../apiConfig'
import { addEventLog } from './EventsLog'


export const getReceipts = (page) => (dispatch) => {
    dispatch(addEventLog(page, CONSTANTS.GET_RECEIPTS_REQUEST))
    dispatch({ type: CONSTANTS.GET_RECEIPTS_REQUEST })
    let endpoint = `${APICONFIG.getReceipts}${page}`
    let tobject = { page: page }
    return getRequest(endpoint).then((res) => {
        let resObject = { ...tobject, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.GET_RECEIPTS_SUCCESS))
        dispatch({ type: CONSTANTS.GET_RECEIPTS_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...tobject, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.GET_RECEIPTS_FAILURE))
        dispatch({ type: CONSTANTS.GET_RECEIPTS_FAILURE })
        return err
    })
}


export const checkActiveSession = (data) => (dispatch) => {
    let payload = {...data, 'device_type': 'web'}
    dispatch({ type: CONSTANTS.CHECK_ACTIVE_SESSION_REQUEST })
    dispatch(addEventLog(payload, CONSTANTS.CHECK_ACTIVE_SESSION_REQUEST))
    return postRequest(APICONFIG.checkActiveSession, payload).then((res) => {
        const finalPayload = {...payload, ...res}
        dispatch(addEventLog(finalPayload, CONSTANTS.CHECK_ACTIVE_SESSION_SUCCESS))
        dispatch({ type: CONSTANTS.CHECK_ACTIVE_SESSION_SUCCESS, data: res })
        return res
    }).catch((err) => {
        const finalPayload = {...payload, ...err}
        dispatch(addEventLog(finalPayload, CONSTANTS.CHECK_ACTIVE_SESSION_FAILURE))
        dispatch({ type: CONSTANTS.CHECK_ACTIVE_SESSION_FAILURE })
        return err
    })
}

export const getTicketDetails = (payload) => (dispatch) => {
    let payloadGetTicket = {...payload, 'device_type': 'web'}
    dispatch({ type: CONSTANTS.GET_TICKET_DETAILS_REQUEST })
    return postRequest(APICONFIG.getSearchTicketUrl, payloadGetTicket).then((res) => {
        dispatch({ type: CONSTANTS.GET_TICKET_DETAILS_SUCCESS, data: res })
        return res
    }).catch((err) => {
        dispatch({ type: CONSTANTS.GET_TICKET_DETAILS_FAILURE, errorMessage: err?.errors?.message })
        return err
    })
}

export const falseLoaderOfPage = () => (dispatch) => {
    dispatch({ type: CONSTANTS.GET_LOADER_FALSE })
}


